import { render, staticRenderFns } from "./ChatBotsIndex.vue?vue&type=template&id=62b7b2c6&"
import script from "./ChatBotsIndex.vue?vue&type=script&lang=ts&"
export * from "./ChatBotsIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports